"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda */
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var TemplatesMonitoring_1 = require("../../monitoring/TemplatesMonitoring");
var getStyles = function () {
    return {
        Container: {
            position: 'relative',
            border: widgets_1.TabStyles.Sizing.BorderWidth + 'px solid ' + widgets_1.TabStyles.Colors.L4,
        },
        // centers button in the middle of the image
        ButtonContainer: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            msTransform: 'translate(-50%, -50%)',
            textAlign: 'center',
        },
        Image: {},
    };
};
var TemplateThumbnailImage = /** @class */ (function (_super) {
    __extends(TemplateThumbnailImage, _super);
    function TemplateThumbnailImage(props) {
        var _this = _super.call(this, props) || this;
        _this.onHover = function (hover) {
            _this.setState({ hover: hover });
        };
        _this.onMouseOver = function () {
            _this.onHover(true);
        };
        _this.onMouseLeave = function () {
            _this.onHover(false);
        };
        _this.onFocus = function () {
            _this.setState({ focus: true });
        };
        _this.onBlur = function () {
            _this.setState({ focus: false });
        };
        _this.state = { hover: false, focus: false };
        _this.onImageLoad = _this.onImageLoad.bind(_this);
        _this.onImageError = _this.onImageError.bind(_this);
        return _this;
    }
    TemplateThumbnailImage.prototype.onImageLoad = function (e) {
        this.props.onFinishedLoading();
    };
    TemplateThumbnailImage.prototype.onImageError = function (e) {
        this.props.onFinishedLoading();
        TemplatesMonitoring_1.noticeImageLoadError(this.props.template.id, this.props.template.thumbnailUrl);
    };
    TemplateThumbnailImage.prototype.selectButton = function () {
        return (React.createElement(widgets_1.ButtonWidget, { testId: 'image-select-template-' + this.props.template.id, children: Localize_1.Messages.SelectTemplateButtonText(), buttonType: widgets_1.ButtonType.OutlineDark, handleClick: function () {
                /*Let the parent div onClick handle this button click*/
            }, style: { cursor: 'pointer' }, tabIndex: 0, title: Localize_1.Messages.TemplateThumbnailImageButtonTitle({
                TEMPLATE_NAME: this.props.template.name,
            }), onFocus: this.onFocus, onBlur: this.onBlur }));
    };
    TemplateThumbnailImage.prototype.containerStyles = function () {
        var containerStyles = getStyles().Container;
        containerStyles.width = this.props.imageWidth;
        containerStyles.height = this.props.imageHeight;
        // Set background color to dark grey on hovering. Creates desired effect in combination with image opacity setting.
        if (this.state.hover || this.state.focus) {
            containerStyles.backgroundColor = widgets_1.TabStyles.Colors.L9;
            containerStyles.cursor = 'pointer';
        }
        return containerStyles;
    };
    TemplateThumbnailImage.prototype.imageStyles = function () {
        var imageStyles = getStyles().Image;
        imageStyles.width = this.props.imageWidth;
        imageStyles.height = this.props.imageHeight;
        if (this.state.hover || this.state.focus) {
            imageStyles.opacity = 0.3;
        }
        else {
            imageStyles.opacity = 1;
        }
        return imageStyles;
    };
    TemplateThumbnailImage.prototype.buttonStyles = function () {
        var buttonStyles = getStyles().ButtonContainer;
        if (this.state.hover || this.state.focus) {
            buttonStyles.opacity = 1;
            buttonStyles.cursor = 'pointer';
        }
        else {
            // This effectively hides button when not hovering over image
            buttonStyles.opacity = 0;
        }
        return buttonStyles;
    };
    TemplateThumbnailImage.prototype.render = function () {
        return (React.createElement("div", { className: "TemplateThumbnailImage", style: this.containerStyles(), onClick: this.props.onClick, onMouseOver: this.onMouseOver, onMouseLeave: this.onMouseLeave },
            React.createElement("img", { src: this.props.template.thumbnailUrl, onLoad: this.onImageLoad, onError: this.onImageError, alt: this.props.template.name, style: this.imageStyles() }),
            React.createElement("div", { className: "button container", style: this.buttonStyles() }, this.selectButton())));
    };
    return TemplateThumbnailImage;
}(React.Component));
exports.TemplateThumbnailImage = TemplateThumbnailImage;
//# sourceMappingURL=TemplateThumbnailImage.js.map